// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 3: JEZUS CHRYSTUS
// ============================================================================
// Poziomy 27-39 (13 poziomów, 39 pytań)

export const chapter3Translations = {
  name: 'Jezus Chrystus',
  description: 'Słowo stało się ciałem... Poznać Chrystusa to życie wieczne',
  
  spiritualWisdom: {
    principle: 'Poznać Jezusa Chrystusa to życie wieczne',
    scripture: 'A to jest życie wieczne: aby poznali Ciebie, jedynego prawdziwego Boga, oraz Tego, którego posłałeś, Jezusa Chrystusa (Jana 17:3)',
    application: 'Każdy aspekt życia Jezusa objawia Boga i karmi naszą duszę na wieczność'
  },
  
  levels: {
    27: {
      name: 'Zwiastowanie',
      challenge: 'Anioł Gabriel został posłany przez Boga do miasta w Galilei...',
      easy: {
        question: 'Który anioł zwiastował Maryi, że urodzi Jezusa?',
        options: ['Michał', 'Gabriel', 'Rafael', 'Uriel'],
        hint: 'Anioł posłaniec Boży',
        funFact: '👼 Gabriel oznacza Moc Boża - anioł wielkich zwiastowań!'
      },
      medium: {
        question: 'Jaka była pierwsza reakcja Maryi na to zwiastowanie?',
        options: [
          'Natychmiastowa radość',
          'Całkowita niedowiara',
          'Zakłopotanie i pytanie Jakże się to stanie?',
          'Strach'
        ],
        hint: 'Praktyczne i uzasadnione pytanie',
        funFact: '🤔 Maryja zadaje logiczne pytanie, ale zachowuje serce otwarte na Boga!'
      },
      hard: {
        question: 'Czego uczy nas poddanie się Maryi woli Bożej?',
        options: [
          'Bierności wobec prób',
          'Wiary, która ufa nawet bez zrozumienia wszystkiego',
          'Ślepego posłuszeństwa',
          'Rezygnacji'
        ],
        hint: 'Chodzi o zaufanie Bogu nawet w nieznane',
        funFact: '🙏 Niech mi się stanie według słowa twego - wzór wiary ufnej!'
      }
    },
    
    28: {
      name: 'Narodzenie',
      challenge: 'Porodziła Syna swego pierworodnego, owinęła Go w pieluszki i położyła w żłobie...',
      easy: {
        question: 'W jakim mieście narodził się Jezus?',
        options: ['Nazaret', 'Jerozolima', 'Betlejem', 'Kafarnaum'],
        hint: 'Miasto Dawida',
        funFact: '🏘️ Betlejem oznacza Dom Chleba - Jezus, chleb życia!'
      },
      medium: {
        question: 'Kto otrzymał jako pierwszy wieść o narodzeniu?',
        options: [
          'Mędrcy',
          'Pasterze na polach',
          'Kapłani świątyni',
          'Rodzina Maryi'
        ],
        hint: 'Prości ludzie strzegący swoich stad',
        funFact: '🐑 Bóg zwiastuje najpierw pokornym pasterzom - Ewangelia dla wszystkich!'
      },
      hard: {
        question: 'Co symbolizuje Jezus narodzony w żłobie?',
        options: [
          'Ubóstwo Jego rodziców',
          'Pokora Boga, który się do nas zniża',
          'Brak miejsca',
          'Wiejska prostota'
        ],
        hint: 'Chodzi o wcielenie Boże w pokorze',
        funFact: '👶 Stworzyciel wszechświata rodzi się w stajni - nieskończona miłość!'
      }
    },

    29: {
      name: 'Mędrcy ze Wschodu',
      challenge: 'Mędrcy ze Wschodu przybyli do Jerozolimy i pytali...',
      easy: {
        question: 'Co poprowadziło mędrców do Jezusa?',
        options: ['Anioł', 'Gwiazda', 'Wizja', 'Mapa'],
        hint: 'Ciało niebieskie na niebie',
        funFact: '⭐ Gwiazda reprezentuje, że Jezus jest światłością narodów!'
      },
      medium: {
        question: 'Jakie dary ofiarowali mędrcy?',
        options: [
          'Żywność',
          'Złoto, kadzidło i mirrę',
          'Cenne szaty',
          'Zabawki'
        ],
        hint: 'Trzy symboliczne i cenne dary',
        funFact: '🎁 Złoto (królewskość), kadzidło (boskość), mirra (ofiara) - cała misja Jezusa!'
      },
      hard: {
        question: 'Co reprezentują ci pogańscy mędrcy w planie Bożym?',
        options: [
          'Wyższość innych religii',
          'Uniwersalność zbawienia ofiarowanego wszystkim ludom',
          'Bogactwo materialne',
          'Starożytna nauka'
        ],
        hint: 'Chodzi o otwarcie zbawienia dla wszystkich narodów',
        funFact: '🌍 Mędrcy zapowiadają Ewangelię, która dotrze do całego świata!'
      }
    },

    30: {
      name: 'Chrzest Jezusa',
      challenge: 'Gdy Jezus został ochrzczony, natychmiast wyszedł z wody...',
      easy: {
        question: 'Kto ochrzcił Jezusa?',
        options: ['Piotr', 'Jan Chrzciciel', 'Andrzej', 'Jakub'],
        hint: 'Poprzednik Jezusa',
        funFact: '🌊 Jan Chrzciciel uważał się za niegodnego rozwiązać sandałów Jezusa!'
      },
      medium: {
        question: 'Co zstąpiło na Jezusa podczas Jego chrztu?',
        options: [
          'Światło',
          'Gołębica (Duch Święty)',
          'Anioł',
          'Tylko głos'
        ],
        hint: 'Ptak symbol pokoju',
        funFact: '🕊️ Gołębica objawia namaszczenie Boże na rozpoczęcie posługi!'
      },
      hard: {
        question: 'Dlaczego Jezus, bez grzechu, dał się ochrzcić?',
        options: [
          'Aby dać przykład',
          'Aby wypełnić wszelką sprawiedliwość i utożsamić się z nami',
          'Z powodu obowiązku religijnego',
          'Aby otrzymać przebaczenie'
        ],
        hint: 'Chodzi o solidarność z grzeszną ludzkością',
        funFact: '❤️ Jezus utożsamia się całkowicie z nami, aby nas lepiej zbawić!'
      }
    },

    31: {
      name: 'Kuszenie na Pustyni',
      challenge: 'Jezus został wyprowadzony przez Ducha na pustynię, aby był kuszony przez diabła...',
      easy: {
        question: 'Jak długo pościł Jezus na pustyni?',
        options: ['30 dni', '40 dni', '50 dni', '60 dni'],
        hint: 'Biblijna liczba próby',
        funFact: '🏜️ Jak Mojżesz i Eliasz, 40 dni intensywnego przygotowania duchowego!'
      },
      medium: {
        question: 'Jak Jezus odrzucił każde kuszenie?',
        options: [
          'Własną siłą',
          'Cytując Pisma',
          'Ignorując szatana',
          'Tylko modlitwą'
        ],
        hint: 'Duchowa broń par excellence',
        funFact: '📖 Napisano... - Słowo Boże, miecz Ducha!'
      },
      hard: {
        question: 'Czego uczy nas kuszenie Jezusa o naszych walkach?',
        options: [
          'Kuszenia są grzechem',
          'Kuszenie może być pokonane Słowem i wiarą',
          'Trzeba uciekać od każdej pustyni',
          'Tylko Jezus może się oprzeć'
        ],
        hint: 'Chodzi o naszą strategię wobec pokus',
        funFact: '⚔️ Jezus pokazuje nam jak zwyciężać: Słowo Boże + aktywna wiara!'
      }
    },

    32: {
      name: 'Pierwsi Uczniowie',
      challenge: 'Jezus powiedział do nich: Pójdźcie za Mną, a uczynię was rybakami ludzi...',
      easy: {
        question: 'Jaki był zawód Piotra i Andrzeja?',
        options: ['Pasterze', 'Rybacy', 'Cieśle', 'Celnicy'],
        hint: 'Zawód nad jeziorem Galilejskim',
        funFact: '🎣 Jezus przemienia rybaków ryb w rybaków dusz!'
      },
      medium: {
        question: 'Jak zareagowali pierwsi uczniowie na wezwanie?',
        options: [
          'Wahali się długo',
          'Prosili o dowody',
          'Zostawili wszystko i natychmiast poszli za Nim',
          'Negocjowali'
        ],
        hint: 'Natychmiastowa i całkowita odpowiedź',
        funFact: '🚶 Autorytet Jezusa był tak oczywisty, że posłuchali natychmiast!'
      },
      hard: {
        question: 'Co oznacza podążanie za Jezusem w naszych czasach?',
        options: [
          'Porzucenie pracy',
          'Życie według Jego nauk i woli',
          'Dołączenie do odizolowanej wspólnoty',
          'Tylko misjonarstwo'
        ],
        hint: 'Chodzi o przemianę życia i priorytetów',
        funFact: '✨ Podążanie za Jezusem przemienia nasze serca, wybory, przeznaczenie!'
      }
    },

    33: {
      name: 'Kazanie na Górze',
      challenge: 'Błogosławieni ubodzy w duchu, albowiem do nich należy królestwo niebieskie...',
      easy: {
        question: 'Jakie jest pierwsze błogosławieństwo Kazania na Górze?',
        options: [
          'Błogosławieni czystego serca',
          'Błogosławieni ubodzy w duchu',
          'Błogosławieni cisi',
          'Błogosławieni którzy wprowadzają pokój'
        ],
        hint: 'Odnosi się do pokory duchowej',
        funFact: '😊 Ubodzy duchem znają swoją potrzebę Boga - brama do Królestwa!'
      },
      medium: {
        question: 'Co Jezus powiedział o tych, którzy wprowadzają pokój?',
        options: [
          'Będą szczęśliwi',
          'Będą nazwani synami Bożymi',
          'Będą kochani',
          'Będą mocni'
        ],
        hint: 'Szczególna boska tożsamość',
        funFact: '👑 Ci, którzy czynią pokój, są podobni do Boga - żywe świadectwo Jego natury!'
      },
      hard: {
        question: 'Jak błogosławieństwa odwracają wartości świata?',
        options: [
          'Potępiając bogactwo',
          'Izolując wierzących',
          'Ogłaszając błogosławionymi tych, których świat gardzi',
          'Znosząc prawa'
        ],
        hint: 'Chodzi o wartości boskie przeciwne wartościom świeckim',
        funFact: '🔄 Błogosławieństwa zmieniają nasze postrzeganie szczęścia i sukcesu!'
      }
    },

    34: {
      name: 'Przypowieści o Królestwie',
      challenge: 'Nauczał ich wielu rzeczy w przypowieściach...',
      easy: {
        question: 'W przypowieści o siewcy, co reprezentuje ziarno?',
        options: [
          'Pieniądze',
          'Słowo Boże',
          'Dobre uczynki',
          'Miłość'
        ],
        hint: 'To, co Jezus głosi i naucza',
        funFact: '🌱 Słowo Boże kiełkuje i rośnie w naszych sercach!'
      },
      medium: {
        question: 'W przypowieści o ziarnie gorczycy, co symbolizuje to małe ziarno?',
        options: [
          'Ludzką słabość',
          'Królestwo, które zaczyna się małe, ale staje się wielkie',
          'Znaczenie szczegółów',
          'Naturę'
        ],
        hint: 'Coś, co rośnie w imponujący sposób',
        funFact: '🌳 Z najmniejszego ziarna wyrasta wielkie drzewo - moc Królestwa!'
      },
      hard: {
        question: 'Dlaczego Jezus nauczał w przypowieściach?',
        options: [
          'Aby skomplikować swoje przesłanie',
          'Aby objawić prawdy duchowe przez znane obrazy',
          'Z powodu braku czasu',
          'Aby przetestować inteligencję'
        ],
        hint: 'Chodzi o udostępnienie tajemnic Królestwa',
        funFact: '💡 Przypowieści objawią otwartym sercom i ukrywają przed zamkniętymi!'
      }
    },

    35: {
      name: 'Cuda Jezusa',
      challenge: 'Uciszył burzę i rzekł do morza: Milcz! Ucisz się!...',
      easy: {
        question: 'Ilu chlebami Jezus nakarmił 5000 mężczyzn?',
        options: ['3 chlebami', '5 chlebami', '7 chlebami', '12 chlebami'],
        hint: 'Taka sama liczba jak ryb',
        funFact: '🍞 5 chlebów i 2 ryby stają się ucztą - boska hojność!'
      },
      medium: {
        question: 'Co powiedzieli uczniowie, gdy Jezus uciszył burzę?',
        options: [
          'To czarodziej',
          'Któż to jest, że nawet wiatr i morze mu są posłuszne?',
          'To normalne',
          'Powinniśmy stąd odejść'
        ],
        hint: 'Pytanie o tożsamość Jezusa',
        funFact: '⛈️ Nawet żywioły rozpoznają swego Stwórcę i Pana!'
      },
      hard: {
        question: 'Jaki jest główny cel cudów Jezusa?',
        options: [
          'Zaimponować tłumom',
          'Objawić swoją boskość i ukazać miłość Boga',
          'Zdobyć wpływy',
          'Pomóc tylko materialnie'
        ],
        hint: 'Chodzi o objawienie boskie i miłosierdzie',
        funFact: '❤️ Każdy cud objawia serce Boga: miłość, miłosierdzie, moc!'
      }
    },

    36: {
      name: 'Przemienienie',
      challenge: 'I przemienił się przed nimi; twarz jego zajaśniała jak słońce...',
      easy: {
        question: 'Którzy uczniowie widzieli przemienienie Jezusa?',
        options: [
          'Wszyscy dwunastu',
          'Piotr, Jakub i Jan',
          'Tylko Piotr i Jan',
          'Kobiety, które szły za nim'
        ],
        hint: 'Wewnętrzny krąg trzech',
        funFact: '⛰️ Piotr, Jakub i Jan: uprzywilejowani świadkowie boskiej chwały!'
      },
      medium: {
        question: 'Jakie postacie ze Starego Testamentu się pojawiły?',
        options: [
          'Abraham i Izaak',
          'Dawid i Salomon',
          'Mojżesz i Eliasz',
          'Adam i Noe'
        ],
        hint: 'Przedstawiciel Prawa i Proroków',
        funFact: '📜 Mojżesz (Prawo) i Eliasz (Prorocy) świadczą o Jezusie!'
      },
      hard: {
        question: 'Co to przemienienie objawia o naturze Jezusa?',
        options: [
          'Jest wielkim prorokiem',
          'Jego ukryta boskość objawia się tymczasowo',
          'Kontroluje światło',
          'Może zmieniać wygląd'
        ],
        hint: 'Chodzi o objawienie Jego boskiej natury',
        funFact: '✨ Boska chwała Jezusa błyszczy - zapowiedź Jego zmartwychwstania!'
      }
    },

    37: {
      name: 'Tryumfalny Wjazd',
      challenge: 'Hosanna Synowi Dawida! Błogosławiony, który przychodzi w imię Pańskie!...',
      easy: {
        question: 'Na jakim zwierzęciu Jezus wjechał do Jerozolimy?',
        options: ['Koń', 'Osioł', 'Wielbłąd', 'Pieszo'],
        hint: 'Zwierzę będące symbolem pokory i pokoju',
        funFact: '🐴 Osioł symbolizuje pokornego króla, który przychodzi w pokoju, nie na wojnę!'
      },
      medium: {
        question: 'Co krzyczał tłum witający Jezusa?',
        options: [
          'Niech żyje Król!',
          'Hosanna! Błogosławiony, który przychodzi w imię Pańskie!',
          'Chwała Bogu!',
          'Wolność!'
        ],
        hint: 'Okrzyk radości i błogosławieństwa',
        funFact: '🌿 "Hosanna" oznacza "zbaw teraz" - wezwanie do boskiego zbawienia!'
      },
      hard: {
        question: 'Dlaczego ten wjazd jest "tryumfalny", ale tragiczny?',
        options: [
          'Było mało ludzi',
          'Tłum, który go wita, odrzuci go za 5 dni',
          'Władze były nieobecne',
          'Padał deszcz'
        ],
        hint: 'Chodzi o niestałość ludzkiego serca',
        funFact: '💔 Ten sam tłum będzie krzyczał "Ukrzyżuj go!" za kilka dni!'
      }
    },

    38: {
      name: 'Ostatnia Wieczerza',
      challenge: 'Bierzcie i jedzcie, to jest moje ciało, które za was będzie wydane...',
      easy: {
        question: 'Co Jezus zrobił stopom swoich uczniów?',
        options: [
          'Pobłogosławił je',
          'Umył je',
          'Namaścił je',
          'Pocałował je'
        ],
        hint: 'Gest pokory i służby',
        funFact: '🦶 Nauczyciel staje się sługą - rewolucja miłości i pokory!'
      },
      medium: {
        question: 'Co Jezus ustanowił podczas tej wieczerzy?',
        options: [
          'Chrzest',
          'Eucharystię (Komunię Świętą)',
          'Modlitwę Pańską',
          'Post'
        ],
        hint: 'Sakrament z chlebem i winem',
        funFact: '🍞🍷 Chleb i wino stają się wiecznymi symbolami ofiary i miłości!'
      },
      hard: {
        question: 'Co oznacza "To czyńcie na moją pamiątkę"?',
        options: [
          'Powtarzajcie tę wieczerzę',
          'Obchodźcie moją śmierć i zmartwychwstanie, aż wrócę',
          'Pamiętajcie moje słowa',
          'Miłujcie się wzajemnie'
        ],
        hint: 'Chodzi o żywą i prorocza pamiątkę',
        funFact: '⏳ Każda Eucharystia głosi śmierć Pana, aż przyjdzie!'
      }
    },

    39: {
      name: 'Getsemani',
      challenge: 'Ojcze mój, jeśli to możliwe, niech ten kielich mnie minie...',
      easy: {
        question: 'Gdzie modlił się Jezus przed aresztowaniem?',
        options: [
          'W świątyni',
          'W Ogrodzie Getsemani',
          'Na Górze Oliwnej',
          'W domu przyjaciół'
        ],
        hint: 'Ogród drzew oliwnych',
        funFact: '🫒 Getsemani oznacza "prasa oliwna" - miejsce intensywnej presji!'
      },
      medium: {
        question: 'Co robili uczniowie, gdy Jezus się modlił?',
        options: [
          'Modlili się z nim',
          'Zasnęli',
          'Stali na straży',
          'Odeszli'
        ],
        hint: 'Nie mogli czuwać nawet jednej godziny',
        funFact: '😴 Duch wprawdzie ochotny, ale ciało słabe - ludzka słabość!'
      },
      hard: {
        question: 'Co agonia Jezusa objawia o Jego naturze?',
        options: [
          'Był tylko człowiekiem',
          'Był w pełni człowiekiem i w pełni Bogiem',
          'Wątpił w swoją misję',
          'Był słaby'
        ],
        hint: 'Chodzi o tajemnicę Wcielenia',
        funFact: '✝️ Jezus w pełni dźwiga ludzką trwogę, pozostając wiernym Bogu!'
      }
    }
  }
};

export default chapter3Translations;
